'use strict';

module.exports = function square(options = {}) {
    return this.multiply(this, options);
};



// WEBPACK FOOTER //
// ./packages/isotopic-distribution/src/utils/square.js